import React from "react";
import Modal from "./Modal";
import { Button } from "./ui";

// Destructive actions state exactly what will be removed and what survives,
// because the answer isn't always obvious — deleting a club takes its courts,
// deleting a player does not take their account.
export default function ConfirmDelete({
  title,
  body,
  confirmLabel = "Delete",
  isDeleting,
  onConfirm,
  onClose,
}) {
  return (
    <Modal
      title={title}
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="danger" onClick={onConfirm} disabled={isDeleting}>
            {isDeleting ? "Deleting" : confirmLabel}
          </Button>
        </>
      }
    >
      <p className="text-sm text-ink-soft">{body}</p>
    </Modal>
  );
}
